const Footer = () => {
  return (
    <footer className="footer container-fluid text-center">
      <p>© 2023 NodePress Blog. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
